import type { RouteRecordRaw } from 'vue-router'
import { guardAdministrationMailAccess } from '@/config/router/navigationsGuards/guardAdministration'

const MODULE_NAME = 'ADMINISTRATION'
const MODULE_ID = 0

const defaultMeta = {
  requiresAuth: true,
  adminAccess: true,
}

const administrationRoutes: Array<RouteRecordRaw> = [
  {
    path: '/administration',
    meta: {
      ...defaultMeta,
    },
    beforeEnter: [guardAdministrationMailAccess],
    children: [
      {
        path: 'mail',
        name: 'AdministrationMail',
        component: () => import('@/views/administration/Mail.vue'),
        meta: {
          ...defaultMeta,
          titleTranslationKey: 'pageTitle.administrationMail',
        },
        beforeEnter: [guardAdministrationMailAccess],
      },
    ],
  },
]

export default administrationRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }))
